import { cn } from '../../lib/utils'
import * as React from 'react'

type CardShadowProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string
}

const CardShadow = React.forwardRef<HTMLDivElement, CardShadowProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-2xl overflow-hidden bg-white',
        'shadow-[0_4px_20px_rgba(0,0,0,0.08)]',
        className,
      )}
      {...props}
    />
  ),
)
CardShadow.displayName = 'CardShadow'

const CardShadowHeader = React.forwardRef<HTMLDivElement, CardShadowProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('bg-gray-100 px-5 py-4', className)}
      {...props}
    />
  ),
)
CardShadowHeader.displayName = 'CardShadowHeader'

const CardShadowTitle = React.forwardRef<HTMLHeadingElement, CardShadowProps>(
  ({ className, ...props }, ref) => (
    <h3
      ref={ref}
      className={cn('text-gray-600 font-medium', className)}
      {...props}
    />
  ),
)
CardShadowTitle.displayName = 'CardShadowTitle'

const CardShadowContent = React.forwardRef<HTMLDivElement, CardShadowProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('px-5 py-5', className)}
      {...props}
    />
  ),
)
CardShadowContent.displayName = 'CardShadowContent'

const CardShadowLabel = React.forwardRef<HTMLDivElement, CardShadowProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('text-sm text-gray-500 mb-2', className)}
      {...props}
    />
  ),
)
CardShadowLabel.displayName = 'CardShadowLabel'

const CardShadowFooter = React.forwardRef<HTMLDivElement, CardShadowProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('px-5 pb-5', className)}
      {...props}
    />
  ),
)
CardShadowFooter.displayName = 'CardShadowFooter'

export {
  CardShadow,
  CardShadowHeader,
  CardShadowTitle,
  CardShadowContent,
  CardShadowLabel,
  CardShadowFooter,
}
